import { apiSlice } from '../apiSlice';
import { API_MESSENGER_PROFILE_URL } from '../../constants/env';
import { MESSAGES } from './messengerProfileMessages';
import { API_TAGS } from '../../constants/api';

export const messengerProfileSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchMessengerProfile: builder.query({
      query: ({ accessToken }) => ({
        url: `me/messenger_profile?fields=get_started,greeting,persistent_menu&access_token=${accessToken}`,
        method: 'GET',
        API_URL: API_MESSENGER_PROFILE_URL,
        params: {},
        errorMessage: {
          showMessage: false
        }
      }),
      providesTags: (result, error, args) => {
        return [{ type: API_TAGS.MESSENGER_PROFILE }];
      }
    }),
    updateMessengerProfile: builder.mutation({
      query: ({ accessToken, data }) => ({
        url: `me/messenger_profile?access_token=${accessToken}`,
        method: 'POST',
        API_URL: API_MESSENGER_PROFILE_URL,
        body: data,
        params: {},
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.UPDATE_MESSENGER_PROFILE.ERROR
        }
      }),
      invalidatesTags: (result, error, args) => {
        if (error) {
          return [];
        }
        return [
          { type: API_TAGS.MESSENGER_PROFILE }
        ];
      }
    }),
    deleteMessengerProfile: builder.mutation({
      query: ({ accessToken, data }) => ({
        url: `me/messenger_profile?access_token=${accessToken}`,
        method: 'DELETE',
        API_URL: API_MESSENGER_PROFILE_URL,
        body: data,
        params: {},
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.DELETE_MESSENGER_PROFILE.ERROR
        }
      }),
      invalidatesTags: (result, error, args) => {
        if (error) {
          return [];
        }
        return [
          { type: API_TAGS.MESSENGER_PROFILE }
        ];
      }
    })
  })
});

export const {
  useFetchMessengerProfileQuery,
  useUpdateMessengerProfileMutation,
  useDeleteMessengerProfileMutation
} = messengerProfileSlice;
